import { Modal, ModalProps } from "antd";
import { isEmpty } from "lodash";
import { ReactNode } from "react";

interface CustomModalProps extends Omit<ModalProps, "visible"> {
  body: ReactNode;
  mainClassName?: string;
  bodyStyle?: any;
  // `visible` is deprecated. `open` is the required prop.
  open: boolean;
}
/**
 * @deprecated
 * This will be deprecated in favor of Mui `Dialog`
 */
export const CustomModal = ({
  body,
  mainClassName = "",
  bodyStyle = {},
  ...rest
}: CustomModalProps) => {
  return (
    <Modal
      bodyStyle={
        isEmpty(bodyStyle)
          ? {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between",
              textAlign: "center",
              padding: "4px",
            }
          : bodyStyle
      }
      className={isEmpty(mainClassName) ? "custom-modal" : mainClassName}
      {...rest}
    >
      {body}
    </Modal>
  );
};
